import React, { useState, useEffect } from 'react';
import './ServicesPage.css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';

import digitalizacao1 from '../../img/digitalizacao-1.png';
import digitalizacao2 from '../../img/digitalizacao-2.jpg';
import digitalizacao3 from '../../img/digitalizacao-3.png';
import software1 from '../../img/software-1.jpg';
import software2 from '../../img/software-2.jpeg';
import software3 from '../../img/software-3.webp';
import consultoria1 from '../../img/consultoria-1.jpeg';
import consultoria2 from '../../img/consultoria-2..avif';
import consultoria3 from '../../img/consultoria-3.jpeg';
import seguranca1 from '../../img/seguranca-1.jpg';
import seguranca2 from '../../img/seguranca-2.jpeg';
import seguranca3 from '../../img/seguranca-3.jpg';

const ServicesPage = () => {
  const [activeImages, setActiveImages] = useState({});
  const [autoPlay, setAutoPlay] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [expandedServices, setExpandedServices] = useState({});

  const services = [
    {
      id: 1,
      title: "Digitalização de Processos",
      shortDescription: "Transforme tarefas manuais em fluxos de trabalho inteligentes.",
      fullDescription: "A Infosfera digitaliza e automatiza processos com qualidade e precisão, reduzindo custos e aumentando a eficiência. Implementamos soluções completas desde a análise até a implantação, garantindo segurança e confiabilidade.",
      benefits: [
        "Redução de até 70% no tempo de execução",
        "Eliminação de erros manuais",
        "Relatórios automáticos em tempo real",
        "Integração com sistemas existentes"
      ],
      images: [
        { src: digitalizacao1, alt: "Análise de Processos", description: "Análise detalhada dos fluxos de trabalho" },
        { src: digitalizacao2, alt: "Gestão de documentos", description: "Assegurar a segurança da informação" },
        { src: digitalizacao3, alt: "Dashboard de Controle", description: "Desenvolvimento e personalização do dashboard" }
      ]
    },
    {
      id: 2,
      title: "Desenvolvimento de Software Sob Medida",
      shortDescription: "Soluções que falam a língua do seu negócio.",
      fullDescription: "Criamos aplicações personalizadas para atender às suas necessidades específicas, garantindo qualidade no código, confiabilidade no desempenho e resultados que superam expectativas.",
      benefits: [
        "Desenvolvimento ágil e iterativo",
        "Testes automatizados de qualidade",
        "Documentação completa do projeto",
        "Suporte pós-implantação"
      ],
      images: [
        { src: software1, alt: "Análise de requisitos", description: "Análise e validação" },
        { src: software2, alt: "Prototipação", description: "Design e arquitetura" },
        { src: software3, alt: "Codificação e implementação", description: "Configuração do sistema" }
      ]
    },
    {
      id: 3,
      title: "Consultoria em TI",
      shortDescription: "Estratégia e tecnologia caminhando juntas.",
      fullDescription: "Nossa consultoria especializada ajuda sua empresa a tomar as melhores decisões tecnológicas. Realizamos análises profundas do seu ambiente TI e elaboramos planos estratégicos personalizados.",
      benefits: [
        "Análise completa do ambiente tecnológico",
        "Plano estratégico personalizado",
        "Recomendações baseadas em melhores práticas",
        "Acompanhamento na implementação"
      ],
      images: [
        { src: consultoria1, alt: "Diagnóstico Técnico", description: "Análise detalhada da infraestrutura atual" },
        { src: consultoria2, alt: "Segurança da informação", description: "Análise de vulnerabilidades e riscos" },
        { src: consultoria3, alt: "Treinamento e suporte", description: "Assistência e resolução de problemas" }
      ]
    },
    {
      id: 4,
      title: "Cibersegurança",
      shortDescription: "Proteção completa para seus dados sensíveis.",
      fullDescription: "Proteja seu negócio contra ameaças cibernéticas com nossas soluções completas de segurança. Implementamos políticas e tecnologias avançadas para garantir a confidencialidade dos seus dados.",
      benefits: [
        "Proteção contra malware e ransomware",
        "Monitoramento de segurança 24/7",
        "Backup e recuperação de desastres",
        "Conformidade com LGPD e outras normas"
      ],
      images: [
        { src: seguranca1, alt: "Prevenção de ataques", description: "Implementação de medidas de segurança" },
        { src: seguranca2, alt: "Detecção e resposta a incidentes", description: "Análise de falhas de segurança e roubo de dados" },
        { src: seguranca3, alt: "Análise de Vulnerabilidades", description: "Testes de penetração e auditoria" }
      ]
    }
  ];

  // Inicializa AOS
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Carousel autoplay
  useEffect(() => {
    if (!autoPlay) return;

    const intervals = services.map(service => {
      return setInterval(() => {
        setActiveImages(prev => ({
          ...prev,
          [service.id]: ((prev[service.id] || 0) + 1) % service.images.length
        }));
      }, 4000);
    });

    return () => intervals.forEach(clearInterval);
  }, [autoPlay, services]);

  const nextImage = (serviceId, total) => {
    setActiveImages(prev => ({
      ...prev,
      [serviceId]: ((prev[serviceId] || 0) + 1) % total
    }));
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 10000);
  };

  const prevImage = (serviceId, total) => {
    setActiveImages(prev => ({
      ...prev,
      [serviceId]: ((prev[serviceId] || 0) - 1 + total) % total
    }));
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 10000);
  };

  const goToImage = (serviceId, index) => {
    setActiveImages(prev => ({ ...prev, [serviceId]: index }));
    setAutoPlay(false);
    setTimeout(() => setAutoPlay(true), 10000);
  };

  const toggleExpand = (serviceId) => {
    setExpandedServices(prev => ({
      ...prev,
      [serviceId]: !prev[serviceId]
    }));
  };

  return (
    <div className={`services-page ${darkMode ? 'dark' : ''}`}>
      <section className="page-header">
        <h1>Nossos Serviços</h1>
        <p>Descubra como cada serviço pode transformar o seu negócio</p>
        <button className="dark-toggle" onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? "☀️ Light" : "🌙 Dark"}
        </button>
      </section>

      <div className="services-grid">
        {services.map((service) => {
          const currentIndex = activeImages[service.id] || 0;
          const currentImage = service.images[currentIndex];
          const isExpanded = expandedServices[service.id] || false;

          return (
            <div
              key={service.id}
              className="service-card"
              data-aos="fade-up"
            >
              <div className="carousel-section">
                <div className="carousel">
                  <div className="carousel-image-container">
                    <img
                      src={currentImage.src}
                      alt={currentImage.alt}
                      className="carousel-image loaded"
                      onError={(e) => {
                        e.target.src = `https://via.placeholder.com/400x250/3498db/ffffff?text=${encodeURIComponent(currentImage.alt)}`;
                      }}
                    />
                    <div className="image-overlay">
                      <div className="image-title">{currentImage.alt}</div>
                      <div className="image-description">{currentImage.description}</div>
                    </div>
                  </div>

                  <div className="carousel-controls">
                    <button
                      className="carousel-btn prev"
                      onClick={() => prevImage(service.id, service.images.length)}
                      aria-label="Imagem anterior"
                    >
                      <FaArrowLeft />
                    </button>

                    <div className="carousel-indicators">
                      {service.images.map((_, index) => (
                        <button
                          key={index}
                          className={`indicator ${index === currentIndex ? 'active' : ''}`}
                          onClick={() => goToImage(service.id, index)}
                          aria-label={`Ir para imagem ${index + 1}`}
                        />
                      ))}
                    </div>

                    <button
                      className="carousel-btn next"
                      onClick={() => nextImage(service.id, service.images.length)}
                      aria-label="Próxima imagem"
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              </div>

              <div className="service-info">
                <h2 className="service-title">{service.title}</h2>
                <p className="service-short-desc">{service.shortDescription}</p>

                <div className="service-full-info">
                  <p className="service-full-desc">
                    {isExpanded ? service.fullDescription : `${service.fullDescription.slice(0, 150)}...`}
                  </p>
                  <button className="toggle-desc-btn" onClick={() => toggleExpand(service.id)}>
                    {isExpanded ? "Ver Menos" : "Ver Mais"}
                  </button>

                  <div className="service-benefits">
                    <h3>Benefícios Principais</h3>
                    <ul>
                      {service.benefits.map((benefit, index) => (
                        <li key={index}>{benefit}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ServicesPage;